import { render, staticRenderFns } from "./cardLaborServiceCompany.vue?vue&type=template&id=b3b6e966&scoped=true"
import script from "./cardLaborServiceCompany.vue?vue&type=script&lang=js"
export * from "./cardLaborServiceCompany.vue?vue&type=script&lang=js"
import style0 from "./cardLaborServiceCompany.vue?vue&type=style&index=0&id=b3b6e966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b6e966",
  null
  
)

export default component.exports